import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import Loadable, { lazyWithRetry } from 'components/Loadable';
import { PublicRoute } from './PublicRoute';

const LoginPage = lazyWithRetry(() => import('sections/authentication/pages/Login'));
const ForgotPasswordPage = lazyWithRetry(() => import('sections/authentication/pages/ForgotPassword'));
const ActivateUser = lazyWithRetry(() => import('sections/authentication/components/ActivateUser'));
const SetPasswordPage = lazyWithRetry(() => import('sections/authentication/components/SetPasswordPage'));
const AuthCallback = lazyWithRetry(() => import('sections/authentication/components/AuthCallback'));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes: RouteObject = {
  path: '/',
  children: [
    {
      path: '/',
      element: <PublicRoute />,
      children: [
        {
          path: 'login',
          element: <LoginPage />
        },
        {
          path: 'activate/:token',
          element: <ActivateUser />
        },
        {
          path: '/reset-password',
          element: <SetPasswordPage />
        },
        {
          path: '/set-password',
          element: <SetPasswordPage />
        },
        {
          path: '/forgot-password',
          element: <ForgotPasswordPage />
        },
        {
          // Auth0 redirects here after Google/Okta login
          // Must match exactly what's set in Auth0 dashboard → Allowed Callback URLs
          path: 'callback',
          element: <AuthCallback />
        }
      ]
    }
  ]
};

export default LoginRoutes;
